import { Table, Spin, message, Image, Form, Input, Space, DatePicker, Radio, Divider, Select, Tooltip, Button, InputNumber, Modal, Row, Col, Popconfirm } from 'antd';
import debounce from 'lodash/debounce';
import APIUtils from '../../api/APIUtils';
import WebLinks from '../../api/WebLinks';
import { useEffect, useState } from 'react';
import constants from '../../constants/constants';
import Cookies from 'js-cookie';
import { useContext } from 'react';
import moment from 'moment';
import { CommonContext, CurrencyContext } from '../../Context';
import dayjs from 'dayjs';
import { getCurrencyName } from '../../globalFunctions/GlobalFunctions';

const { Column } = Table;
const { RangePicker } = DatePicker;
const { Option } = Select;
const { TextArea } = Input;

const OrdersAdminCS = (props) => {
	//Variable Declaration
  const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;
	const currencyContext=useContext(CurrencyContext);
	const [ordersData, setOrders] = useState([]);
  const [ordersPendingData, setOrdersPendingData] = useState([]);
	const [suppliers, setSuppliers] = useState([]);
	const [pageNumber, setPageNumber] = useState(1);
	const [sortDesc, setSortDesc] = useState(false);
	const [total, setTotal] = useState(0);
	const [loading, setloading] = useState(false);
	const [rangePickerValue, setRangePickerValue] = useState([]);
	const [suplierListLoader,setSuplierListLoader]= useState(false);
	const [allowedSupplierList, setAllowedSupplierList] = useState([]);
  const [allowedSupplierCSList, setAllowedSupplierCSList] = useState([]);
  const [buyerBillingList, setBuyerBillingList] = useState([]);
  const [productsOrderList, setProductOrderList] = useState([]);
  const [selectedBuyerIds,setSelectedBuyerIds]=useState([]);
  const [selectedSupplierIds,setSelectedsupplierIds]=useState([]);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isEditModalNoInvoiceOpen, setIsEditModalNoInvoiceOpen] = useState(false);
  const [contract,setContract]=useState("");
  const [billing,setBilling]=useState("");
  const [showBilling,setShowBilling]=useState("f");
  const [productsListLoader, setProductsListLoader] = useState(false);
  const [selectedProductIds, setSelectedProductIds] = useState([]);
	const [form] = Form.useForm();
  const [formCreate] = Form.useForm();
  const [formNoinvoice]= Form.useForm();

  // Table columns
  const columns = [
    {
      title: 'Id',
      dataIndex: 'id',
      key: 'id',
      sorter: (a, b) =>
        (a?.id ?? 0) - (b?.id ?? 0)
    },
    {
			title: 'Created On',
			dataIndex: 'createdOn',
			key: 'createdOn',
			render: (createdOn) => {
					 {return<span className='whitespace-nowrap'><p>{moment(createdOn).format('YYYY-MM-DD')}</p></span>}
			},
			sorter: (a, b) => moment(a.createdOn).unix() - moment(b.createdOn).unix(),
		},
    {
      title: 'Buyer',
      dataIndex: 'buyerName',
      key: 'buyerName',
    },
    {
      title: 'Customer Success Name',
      dataIndex: 'customerSuccessName',
      key: 'customerSuccessName',
    },
		{
			title: 'Billing Start',
			dataIndex: 'billingDateStart',
			key: 'billingDateStart',
			render: (billingDateStart) => {
        {return<span className='whitespace-nowrap'><p>{moment(billingDateStart).format('YYYY-MM-DD')}</p></span>}
      },
      sorter: (a, b) => moment(a.billingDateStart).unix() - moment(b.billingDateStart).unix(),
    },
		{
			title: 'Billing End',
			dataIndex: 'billingDateEnd',
			key: 'billingDateEnd',
			render: (billingDateEnd) => {
					{return<span className='whitespace-nowrap'><p>{moment(billingDateEnd).format('YYYY-MM-DD')}</p></span>}
			},
			sorter: (a, b) => moment(a.billingDateEnd).unix() - moment(b.billingDateEnd).unix(),
		},
    {
			title:"Suppliers",
			dataIndex: 'suppliers',
			key: 'suppliers',
			width: '20%',
			render: (text, record, index) =>
			<>
				{ record.logoURL && record.logoURL!==""? <Image src={record.logoURL} preview={false} width={100}/> : <span className='uppercase font-bold text-gray-400'>{record.supplierName} </span>}
			</>
		},
    {
      title: 'Product',
      dataIndex: 'productName',
      key: 'productName',
      sorter: (a, b) => a.productName - b.productName,
    },
    {
      title: 'Product Type',
      dataIndex: 'productType',
      key: 'productType',
      sorter: (a, b) => a.productType - b.productType,
    },
    {
      title: 'Billing Period',
      dataIndex: 'billingPeriod',
      key: 'billingPeriod',
      sorter: (a, b) => a.billingPeriod.localeCompare(b.billingPeriod),
    },
		{
			title: 'Contract Start',
			dataIndex: 'startOfContract',
			key: 'startOfContract',
			render: (startOfContract) => {
					 {return<span className='whitespace-nowrap'><p>{moment(startOfContract ).format('YYYY-MM-DD')}</p></span>}
			},
			sorter: (a, b) => moment(a.startOfContract ).unix() - moment(b.startOfContract ).unix(),
		},
		{
			title: 'Contract End',
			dataIndex: 'endOfContract',
			key: 'endOfContract',
			render: (endOfContract) => {
					{return<span className='whitespace-nowrap'><p>{moment(endOfContract ).format('YYYY-MM-DD')}</p></span>}
			},
			sorter: (a, b) => moment(a.endOfContract ).unix() - moment(b.endOfContract ).unix(),
		},
    {
      title: 'Contract Period',
      dataIndex: 'contractPeriod',
      key: 'contractPeriod',
      sorter: (a, b) => a.contractPeriod.localeCompare(b.contractPeriod),
    },
    {
      title: 'Invoice Details',
      key: 'invoiceDetails',
      render: (_, record) => {
        const details = record?.invoiceDetails;
        if (!details) return '';

        return record?.id ? `${record.id} - ${details}` : details;
      },
      sorter: (a, b) => a.invoiceDetails.localeCompare(b.invoiceDetails),
    },
    {
      title: 'Invoice Currency',
      dataIndex: 'invoiceCurrency',
      key: 'invoiceCurrency',
      //sorter: (a, b) => a.invoiceCurrency - b.invoiceCurrency,
    },
    {
      title: 'Invoice Amount',
      dataIndex: 'invoiceAmount',
      key: 'invoiceAmount',
      sorter: (a, b) => a.invoiceAmount - b.invoiceAmount,
    },
		{
      title: 'Invoice ID',
      dataIndex: 'invoiceId',
      key: 'invoiceId',
      sorter: (a, b) => a.invoiceId - b.invoiceId,
      render: (invoiceId,item) => {
        {return invoiceId?<span>{invoiceId}</span>:item?.contractPeriod?.toLowerCase()!=="skip" ?item.doNotInvoice===false ?<Button type="link" onClick={()=>ChangeInvoiceBlock(true,item)}>Block</Button>:<Button type='link' onClick={()=>ChangeInvoiceBlock(false,item)}>Blocked</Button>:null}
    },
    },
    {
			title: 'Invoiced On',
			dataIndex: 'invoiceIdUpdatedOn',
			key: 'invoiceIdUpdatedOn',
			render: (invoiceIdUpdatedOn,item) => {
					 {return invoiceIdUpdatedOn?<span className='whitespace-nowrap'><p>{moment(invoiceIdUpdatedOn).format('YYYY-MM-DD')}</p></span>:item.masterBuyer===true || item?.contractPeriod?.toLowerCase()==="skip"?
           <Popconfirm title="Sure you want to delete?" onConfirm={() => handleDelete(item.id)} placement="left">
            <Button type='link'>Delete</Button>
          </Popconfirm>
           :""}
			},
			sorter: (a, b) => moment(a.invoiceIdUpdatedOn).unix() - moment(b.invoiceIdUpdatedOn).unix(),
		},
  ];
  const invoiceColumns=[
    {
			dataIndex: 'buyerName',
			key: 'buyerName',
		},
    {
			dataIndex: 'customerSuccessName',
			key: 'customerSuccessName',
      render:(customerSuccessName)=>{
        {return <span>{customerSuccessName?customerSuccessName:"None"}</span>}
      },
		},
    {
			dataIndex: 'name',
			key: 'name',
      render: (_,item) => {
        {return<span className='whitespace-nowrap'><Button type='link' onClick={()=>setBuyerDetails(item.id)}>Create Order</Button></span>}
    },
		},
    {
			dataIndex: 'name',
			key: 'name',
      render: (_,item) => {
        {return<span className='whitespace-nowrap'><Button type='link' onClick={()=>setBuyerDetailsNoInvoice(item.id)}>Do Not Invoice This Month</Button></span>}
   },
    },
  ]

	//On page load
	useEffect(() => {
		const date1 = dayjs().startOf('month').format("MMM-YYYY")
		form.setFieldsValue({rangePicker:dayjs().startOf('month')});
		setRangePickerValue(
			date1
			);
		fetchData(date1,null,null,null);
    fetchPendingInvoiceData(date1,null,null,null);
		getAllowedBuyers();
    getAllowedSuppliers();
    getAllOrderProducts();
    getBuyersBillingEnabled();
	}, [props]);

	const isBillingPostPay = (record) => record?.billingPostPay;

	//Functions
	//Function to fetch orders data
	const fetchData = async (dateString,buyerids,supplierids,productids) => {
		setloading(true);
    let url=WebLinks.GetOrdersAdminCS + buyerId +
    '&dateFilter=' + dateString ;
    if(buyerids&&buyerids.length>0){
          url= url+"&customerSuccessBuyerId="+buyerids
    }
    if(supplierids&&supplierids.length>0){
			url= url+"&supplierId="+supplierids
		}
    if (productids && productids.length > 0) {
      url = url + "&productId=" + productids
    }
    const orders = await APIUtils.apiCall("GET", url, null);
    if (orders.isCatch) {
          message.error(constants.ERROR_MESSAGE);
    } else {
          if (orders.resultObj?.statusCode === "2000") {
            setOrders(orders.resultObj.data)
            setTotal(orders.resultObj.data?.getCount | 0);
          } else {
            setOrders([]);
            setTotal(0);
            message.success(orders.resultObj?.message | constants.ERROR_MESSAGE)
          }
    }
    setloading(false);
	}

  //Delete record
  const handleDelete = async(id) => {
    const deleteResponse = await APIUtils.apiCall("DELETE",WebLinks.DeleteBuyerOrder+id);
    if(deleteResponse.isCatch || deleteResponse?.resultObj?.statusCode!=='2000'){
      message.error( deleteResponse?.resultObj?.message || constants.ERROR_MESSAGE);
    }else{
      message.success(deleteResponse?.resultObj?.message)
      fetchData(rangePickerValue,selectedBuyerIds,selectedSupplierIds,selectedProductIds);
    }
  };

  const ChangeInvoiceBlock= async(value,record)=>{
		const EditResponse = await APIUtils.apiCall("PUT",WebLinks.PutBlocKInvoice+record.id+"&doNotInvoice="+value);
		if(EditResponse.isCatch || EditResponse?.resultObj?.statusCode!=='2000'){
			message.error( EditResponse?.resultObj?.message || constants.ERROR_MESSAGE);
		}else{
      const tempOrders = ordersData.map((item) => 
      item.id === record.id ? { ...item, doNotInvoice: value } : item
      );
      setOrders(tempOrders);
			message.success(EditResponse?.resultObj?.message);
		}
  };

	const fetchPendingInvoiceData = async (dateString,buyerids,supplierids,productids) => {
		setloading(true);
		let url=WebLinks.GetOrderPendingInvoiceData
		+'date=' + dateString ;
    if(buyerids&&buyerids.length>0){
      url=url+"&customerSuccessBuyerId="+buyerids
    }
    if(supplierids&&supplierids.length>0){
			url= url+"&supplierId="+supplierids
		}
    if(productids&&productids.length>0){
			url= url+"&productId="+productids
		}
		const orders = await APIUtils.apiCall("GET", url, null);
		if (orders.isCatch) {
			message.error(constants.ERROR_MESSAGE);
		} else {
			if (orders.resultObj?.statusCode === "2000") {
				setOrdersPendingData(orders.resultObj.data)
			} else {
				setOrdersPendingData([]);
				message.success(orders.resultObj?.message | constants.ERROR_MESSAGE)
			}
		}
		setloading(false);
	}
	//Function to get Allowed Buyers list
	const getAllowedBuyers =async()=>{
		setSuplierListLoader(true);
		const response = await APIUtils.apiCall('GET',WebLinks.GetBuyerCSList);
		if(!response.isCatch && response.resultObj.statusCode==="2000"){
			setAllowedSupplierList(response?.resultObj?.data||[])
			setSuplierListLoader(false);
		}else{
			setAllowedSupplierList([]);
			setSuplierListLoader(false);
			message.error(response.resultObj.message);
		}
	}

  	//Function to get Allowed suppliers list
	const getAllowedSuppliers =async()=>{
		setSuplierListLoader(true);
		const response = await APIUtils.apiCall('GET',WebLinks.GetALlAllowedSuppliersAllowedOrders);
		if(!response.isCatch && response.resultObj.statusCode==="2000"){
			setAllowedSupplierCSList(response?.resultObj?.data||[])
			setSuplierListLoader(false);
		}else{
			setAllowedSupplierCSList([]);
			setSuplierListLoader(false);
			message.error(response.resultObj.message);
		}
	}

	//Function to get buyers billing enables
	const getBuyersBillingEnabled =async()=>{
		setSuplierListLoader(true);
		const response = await APIUtils.apiCall('GET',WebLinks.GetBuyerCSBillingList);
		if(!response.isCatch && response.resultObj.statusCode==="2000"){
			setBuyerBillingList(response?.resultObj?.data||[])
			setSuplierListLoader(false);
		}else{
			setBuyerBillingList([]);
			setSuplierListLoader(false);
			message.error(response.resultObj.message);
		}
	}

  //Function to get order products
  const getAllOrderProducts= async()=>{
    setProductsListLoader(true);
    const response = await APIUtils.apiCall('GET',WebLinks.GetOrderProductList);
    if(!response.isCatch && response.resultObj.statusCode==="2000"){
      setProductOrderList(response?.resultObj?.data||[])
      setProductsListLoader(false);
    } else{
      setProductOrderList([]);
      setProductsListLoader(false);
      message.error(response.resultObj.message);
    }
  }

 	//Function on change of supplier selection
	const handleBuyersSelect=(selectedBuyers)=>{
		if(selectedBuyers.length>0){
			let tempSelectedSuppliers=selectedBuyers.filter(value => value !== 'showall');
			let selectedBuyersFinal=tempSelectedSuppliers.length>0?tempSelectedSuppliers:"";
			form.setFieldsValue({
				supplierList:selectedBuyersFinal
			})
			setSelectedBuyerIds(selectedBuyersFinal);
      fetchPendingInvoiceData(rangePickerValue, selectedBuyersFinal, selectedSupplierIds, selectedProductIds);
      fetchData(rangePickerValue,selectedBuyersFinal,selectedSupplierIds,selectedProductIds);
		}else{
			form.setFieldsValue({
				supplierList:["showall"]
			})
			setSelectedBuyerIds([]);
      fetchPendingInvoiceData(rangePickerValue, null, selectedSupplierIds, selectedProductIds);
      fetchData(rangePickerValue,null,selectedSupplierIds,selectedProductIds);
		}
	}

 	//Function on change of supplier selection
   const handleSupplierSelect=(selectedSuppliers)=>{
		if(selectedSuppliers.length>0){
			let tempSelectedSuppliers=selectedSuppliers.filter(value => value !== 'showall');
			let selectedSuppliersFinal=tempSelectedSuppliers.length>0?tempSelectedSuppliers:"";
			form.setFieldsValue({
				supplierListCS:selectedSuppliersFinal
			})
			setSelectedsupplierIds(selectedSuppliersFinal);
      fetchPendingInvoiceData(rangePickerValue, selectedBuyerIds, selectedSuppliersFinal, selectedProductIds);
      fetchData(rangePickerValue,selectedBuyerIds,selectedSuppliersFinal,selectedProductIds);
  		}else{
			form.setFieldsValue({
				supplierListCS:["showall"]
			})
			setSelectedsupplierIds([]);
      fetchPendingInvoiceData(rangePickerValue, selectedBuyerIds, null, selectedProductIds);
      fetchData(rangePickerValue,selectedBuyerIds,null,selectedProductIds);
		}
	}
  //Function on change of product selection
  const handleProductSelect = (selectedProducts) => {
    if (selectedProducts.length > 0) {
      let tempSelectedProducts = selectedProducts.filter(value => value !== 'showall');
      let selectedProductsFinal = tempSelectedProducts.length > 0 ? tempSelectedProducts : "";
      form.setFieldsValue({
        productsList: selectedProductsFinal
      })
      setSelectedProductIds(selectedProductsFinal);
      fetchPendingInvoiceData(rangePickerValue, selectedBuyerIds, selectedSupplierIds, selectedProductsFinal);
      fetchData(rangePickerValue, selectedBuyerIds, selectedSupplierIds, selectedProductsFinal);
    } else {
      form.setFieldsValue({
        productsList: ["showall"]
      })
      setSelectedProductIds([]);
      fetchPendingInvoiceData(rangePickerValue, selectedBuyerIds, selectedSupplierIds, null);
      fetchData(rangePickerValue, selectedBuyerIds, selectedSupplierIds, null);
    }
  }

	const RangePickerChanged = debounce((_, dateStrings) => {
		setRangePickerValue(dateStrings);
    fetchData(dateStrings, selectedBuyerIds, selectedSupplierIds, selectedProductIds);
    fetchPendingInvoiceData(dateStrings,selectedBuyerIds,selectedSupplierIds, selectedProductIds);
	}, 500);

  //Function to save edited job
  const saveDetails = async (values) => {
    let payload = {
      //buyerId: buyerId,
      buyerId: values?.buyersSelected,
      supplierId: values?.supplier,
      productId: values?.orderProductId,
      billingDateStart: dayjs(values?.contractDatePicker).format(constants.DateFormat2),
      billingDateEnd: dayjs(values?.contractDatePicker).format(constants.DateFormat2),
      buyerOrderProductId: values?.orderProductId,
      contractPeriod: values?.contractPeriod,
      billingPeriod: values?.billingPeriod,
      invoiceCurrency: values?.invoiceCurrency,
      invoiceAmount: values?.invoiceAmt,
      contractAmount: values?.contractAmount,
      createdByBuyerId: Cookies.get(constants.COOKIE_LOGGED_BUYER_ID),
      contractStartDate:dayjs(values?.contractDatePicker).format(constants.DateFormat2),
      contractEndDate: dayjs(values?.contractDatePicker).format(constants.DateFormat2),
      purchaseOrderInfo: values?.orderInfo,
      notesToIssuer:values?.noteToIssuer,
    }
 
    let method, url, body;
    method = "POST";
    url = WebLinks.AddOrderDetails;
    const response = await APIUtils.apiCall(method, url,JSON.stringify(payload));
    if (!response.isCatch || response.resultObj.statusCode === "2000") {
      handleCancel();
      message.success(response.resultObj.message);
      fetchData(rangePickerValue, selectedBuyerIds,selectedSupplierIds,selectedProductIds);
      fetchPendingInvoiceData(rangePickerValue,selectedBuyerIds,selectedSupplierIds,selectedProductIds);
    } else {
      handleCancel();
      message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
    }
  };
    const saveNoInvoiceDetails = async (values) => {
    let payload = {
      //buyerId: buyerId,
      buyerId: values?.buyersSelected,
      billingDateStart: dayjs(values?.contractDatePicker).format(constants.DateFormat2),
      billingDateEnd: dayjs(values?.contractDatePicker)?.add(1, 'month')?.format(constants.DateFormat2),
      //buyerOrderProductId: values?.orderProductId,
      contractPeriod: "Skip",
      billingPeriod: "Skip",
      invoiceCurrency: values?.invoiceCurrency,
      invoiceAmount: 0,
      contractAmount: 0,
      createdByBuyerId: Cookies.get(constants.COOKIE_LOGGED_BUYER_ID),
      contractStartDate:dayjs(values?.contractDatePicker).format(constants.DateFormat2),
      contractEndDate: dayjs(values?.contractDatePicker)?.add(1, 'month')?.format(constants.DateFormat2),
      invoiceDetails: values?.skipReason,
    }
 
    let method, url, body;
    method = "POST";
    url = WebLinks.NoOrderOrderDetails;
    const response = await APIUtils.apiCall(method, url,JSON.stringify(payload));
    if (!response.isCatch || response.resultObj.statusCode === "2000") {
      handleCancelNoInvoice();
      message.success(response.resultObj.message);
      fetchData(rangePickerValue, selectedBuyerIds,selectedSupplierIds, selectedProductIds);
      fetchPendingInvoiceData(rangePickerValue,selectedBuyerIds,selectedSupplierIds, selectedProductIds);
    } else {
      handleCancelNoInvoice();
      message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
    }
  };

  const handleCancel = () => {
    formCreate.resetFields();
    setIsEditModalOpen(false);
  };

  const handleCancelNoInvoice = () => {
    formNoinvoice.resetFields();
    setIsEditModalNoInvoiceOpen(false);
  };

  //on Contact change
  const onContractChange=(e)=>{
    setContract(e);
    setBilling(e);
    resetInvoiveAmount();
    formCreate.setFieldsValue({
      billingPeriod: e
    })
    if(e==="Monthly" || e==="One Off"){
      setShowBilling("t");
    }else{
      setShowBilling("f")
    }
  }

  //Set default currency
  const setDefaultCurrency=()=>{
    let curr=getCurrencyName(currencyContext.currency);
    formCreate.setFieldsValue({
      invoiceCurrency:curr
    })
  };

  //Set Invoice amount
  const setInvoiceAmount=(val)=>{
    let tempInvoiceVal=0;
    if(billing!==""&&contract!==""){
      if(billing===contract){
        tempInvoiceVal=val;
      }else if(billing==="Monthly"&&contract==="Quarterly"){
        tempInvoiceVal=val/3;
      }else if(billing==="Monthly" && contract==="Annually"){
        tempInvoiceVal=val/12;
      }else if(billing==="Quarterly" && contract==="Annually"){
        tempInvoiceVal=val/4;
      }else if(billing==="SixMonthly" && contract==="Annually"){
        tempInvoiceVal=val/2;
      }else if(billing==="Monthly" && contract==="TwoMonthly"){
        tempInvoiceVal=val/2;
      }else if(billing==="TwoMonthly" && contract==="SixMonthly"){
        tempInvoiceVal=val/3;
      }else if(billing==="Quarterly" && contract==="SixMonthly"){
        tempInvoiceVal=val/2;
      }else if(billing==="Monthly" && contract==="SixMonthly"){
        tempInvoiceVal=val/6;
      }else if(billing==="Annually" && contract==="TwoYearly"){
        tempInvoiceVal=val/2;
      }else if(billing==="SixMonthly" && contract==="TwoYearly"){
        tempInvoiceVal=val/4;
      }else if(billing==="Quarterly" && contract==="TwoYearly"){
        tempInvoiceVal=val/8;
      }else if(billing==="Monthly" && contract==="TwoYearly"){
        tempInvoiceVal=val/24;
      }else if(billing==="Annually" && contract==="ThreeYearly"){
        tempInvoiceVal=val/3;
      }else if(billing==="SixMonthly" && contract==="ThreeYearly"){
        tempInvoiceVal=val/6;
      }else if(billing==="Quarterly" && contract==="ThreeYearly"){
        tempInvoiceVal=val/12;
      }else if(billing==="Monthly" && contract==="ThreeYearly"){
        tempInvoiceVal=val/36;
      }else{
        tempInvoiceVal=val;
      }
      formCreate.setFieldsValue({
        invoiceAmt: parseFloat(Number(tempInvoiceVal).toFixed(2))
      })
    }else{
      resetInvoiveAmount();
      message.error("Please select billing/contract period.")
    }
  };
  const resetInvoiveAmount=()=>{
    formCreate.setFieldsValue({
      invoiceAmt:[],
      contractAmount:[]
    })
  };

  const setBuyerDetails=(buyerId)=>{
    setIsEditModalOpen(true);
    const selectedMonth = dayjs(form.getFieldValue("rangePicker"));
    formCreate.setFieldsValue({
      buyersSelected:buyerId,
      contractDatePicker: dayjs(selectedMonth, 'YYYY-MM').startOf('month')
    });
    setDefaultCurrency();
  }

  
  const setBuyerDetailsNoInvoice=(buyerId)=>{
    setIsEditModalNoInvoiceOpen(true);
    const selectedMonth = dayjs(form.getFieldValue("rangePicker")).format("MMM-YYYY");
    formNoinvoice.setFieldsValue({
      buyersSelected:buyerId,
      contractDatePicker:dayjs(selectedMonth).startOf('month')
    })
  }

	//Render
	return (
    <>
    <div className='uppercase font-bold text-xl'>CS REP ORDERS</div>
			<Divider className='my-3'/>
		<div>
			<div className='flex flex-wrap gap-3 justify-between items-center mb-3'>
				<Space wrap>
					<Form form={form}>
						<Space wrap>
						<Form.Item name="rangePicker" className='mb-0'>
							<DatePicker picker="month"
								//placeholder={["From", "To"]}
								onChange={RangePickerChanged}
								format={constants.MonthFormat} />
						</Form.Item>
            <Tooltip title="CSM">
						<Form.Item name="supplierList" className='mb-0'>
              <Select
                loading={suplierListLoader}
                className='!w-60'
                // value={selectedSupplier || []}
                placeholder={constants.supplierName}
                mode='multiple'
                allowClear
                defaultValue={"showall"}
                showSearch
              filterOption={(input, option) =>
                  option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
                onChange={(e) => handleBuyersSelect(e)}
                >
                  <Option key='showall' value='showall'>Show all</Option>
                    {allowedSupplierList?.map((supplier) => (
                      <Option key={supplier.id}
                          value={supplier.id}
                      >
                      {supplier.buyerName}</Option>
                ))}
              </Select>
            </Form.Item></Tooltip>
            <Tooltip title="Suppliers">
            <Form.Item name="supplierListCS" className='mb-0'>
              <Select
                loading={suplierListLoader}
                className='!w-60'
                // value={selectedSupplier || []}
                placeholder={constants.supplierName}
                mode='multiple'
                allowClear
                defaultValue={"showall"}
                showSearch
              filterOption={(input, option) =>
                  option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
                onChange={(e) => handleSupplierSelect(e)}
                >
                  <Option key='showall' value='showall'>Show all</Option>
                  <Option key={50} value={50}>Mixed Media CPA </Option>
                    {allowedSupplierCSList?.map((supplier) => (
                      <Option key={supplier.supplierId}
                          value={supplier.supplierId}
                      >
                      {supplier.name}</Option>
                ))}
              </Select>
            </Form.Item></Tooltip>
            <Tooltip title="Products">
              <Form.Item name="productsList" className='mb-0'>
                <Select
                  loading={productsListLoader}
                  className='!w-60'
                  placeholder={"Products"}
                  mode='multiple'
                  allowClear
                  defaultValue={"showall"}
                  showSearch
                  filterOption={(input, option) =>
                    option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={(e) => handleProductSelect(e)}
                >
                  <Option key='showall' value='showall'>Show all</Option>
                  {productsOrderList?.map((product) => (
                    <Option key={product.id}
                      value={product.id}
                    >
                      {product.productName}</Option>
                  ))}
                </Select>
              </Form.Item></Tooltip>
						</Space>
					</Form>
          <Tooltip placement='right' title={constants.CreatOrder}>
            <Button  onClick={(e) => { 
              setIsEditModalOpen(true);setDefaultCurrency();
              const selectedMonth = dayjs(form.getFieldValue("rangePicker"));
              formCreate.setFieldsValue({
              contractDatePicker: dayjs(selectedMonth, 'YYYY-MM').startOf('month')
            });
            }}  className="bg-green-800 text-white hover:!text-white hover:!border-green-500" > {constants.CreatOrder}</Button>
          </Tooltip>
				</Space>
			</div>
      <div>
        <span className='font-bold text-sm'>Pending Invoices:</span>
        <Row>
          <Col span={18}>
            {ordersPendingData.length>0?
            <Table
              size='small'
              onRow={(record) => ({
                className: record.billingPostPay ? "billing-post-pay-row" : "",
                style: record.billingPostPay
                  ? { backgroundColor: "#fef3c7" }
                  : undefined,
              })}
              pagination={false}
              columns={invoiceColumns}
              showHeader={false}
              dataSource={ordersPendingData}
            />:
            <><span className='font-semibold text-xs mb-3'>No Pending Invoices</span></>}
          </Col>
        </Row>
      </div>
			<div className='overflow-x-auto mt-4'>
			<Table
          loading={loading}
          size='small'
            onRow={(record) => ({
              className: record.billingPostPay ? "billing-post-pay-row" : "",
              style: record.billingPostPay
                ? { backgroundColor: "#fef3c7" }
                : undefined,
            })}
          pagination={{
            //current: pagination.current,
            showSizeChanger: true,
            pageSizeOptions: ["200", "500", "1000", "2000"],
            defaultPageSize: 200,
            // onChange: (page, pageSize) => {
            //   setPagination({
            //     current: page,
            //     pageSize: pageSize
            //   });
            // }
          }}
          columns={columns}
          dataSource={ordersData}
          //onChange={(pagination, filters, sorter, extra)=>setCount(extra?.currentDataSource?.length||0)}
        />
			</div>
      <Modal
        title={"Create Order"}
        open={isEditModalOpen}
        onCancel={handleCancel}
        destroyOnClose
        //okText={<span className="capitalize">Save</span>}
       // onOk={() => form.submit()}
        style={{ top: 20 }}
        width={800}
        footer={
          [
          <Button key="cancel" onClick={()=>handleCancel()}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={()=>formCreate.submit()}>
            Save
          </Button>,
        ]
      }
      >
        <Form form={formCreate} name="form_in_modal" layout="vertical" onFinish={saveDetails}>
          <div className="grid xs:grid-cols-1 lg:grid-cols-2 gap-4">
          <Form.Item
              name="buyersSelected"
              label="Buyer"
              className="mb-0"
              rules={[
                {
                  required: true,
                  message: "Required field",
                },
              ]}
            >
              <Select loading={suplierListLoader} onChange={()=>setDefaultCurrency()} placeholder="Select Buyer"
              showSearch
              filterOption={(input, option) =>
                  option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
              {buyerBillingList?.map((supplier) => (
                      <Option key={supplier.id}
                          value={supplier.id}
                      >
                      {supplier.buyerName}</Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="supplier"
              label="Supplier"
              className="mb-0"
              rules={[
                {
                  required: true,
                  message: "Required field",
                },
              ]}
            >
              <Select loading={suplierListLoader} onChange={()=>setDefaultCurrency()} placeholder="Select Supplier"
              showSearch
              filterOption={(input, option) =>
                  option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                <Option key={50} value={50}>Mixed Media CPA </Option>
              {allowedSupplierCSList?.map((supplier) => (
                      <Option key={supplier.supplierId}
                          value={supplier.supplierId}
                      >
                      {supplier.name}</Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="contractDatePicker" label="Start Date" className='mb-0'
            rules={[
              {
                required: true,
                message: "Required field",
              },
            ]}
            >
                <DatePicker placeholder='From Date' format={constants.DateFormat2}/>
						</Form.Item>
            {/* <Form.Item name="bilingDateEnd" label="Billing Start Date" className='mb-0'
            rules={[
              {
                required: true,
                message: "Required field",
              },
            ]}
            >
            <DatePicker placeholder='From Date' format={constants.DateFormat2}/>
						</Form.Item> */}
            <Form.Item
              name="contractPeriod"
              label="Contract Period"
              className="mb-0"
              rules={[
                {
                  required: true,
                  message: "Required field",
                },
              ]}
            >
              <Select placeholder="Select Period" onChange={(e)=>onContractChange(e)}>
                <Option key="oneoff" value="One Off">One Off</Option>
                <Option key="monthly" value="Monthly">Monthly</Option>
                <Option key="twomonthly" value="TwoMonthly">Two Monthly</Option>
                <Option key="quaterly" value="Quarterly">Quarterly</Option>
                <Option key="sixmonthly" value="SixMonthly">Six Monthly</Option>
                <Option key="annually" value="Annually">Annually</Option>
                <Option key="twoyearly" value="TwoYearly">Two Yearly</Option>
                <Option key="threeyearly" value="ThreeYearly">Three Yearly</Option>                
              </Select>
            </Form.Item>
            <Form.Item
              name="billingPeriod"
              label="Billing Period"
              className="mb-0"
              rules={[
                {
                  required: true,
                  message: "Required field",
                },
              ]}
            >
              <Select placeholder="Select Period" onChange={(e)=>{setBilling(e);resetInvoiveAmount();}} disabled={showBilling=="t"?true:false}>
                {contract==="Annually"?<>
                  <Option key="monthly" value="Monthly">Monthly</Option>
                  <Option key="quaterly" value="Quarterly">Quarterly</Option>
                  <Option key="sixmonthly" value="SixMonthly">Six Monthly</Option>
                  <Option key="annually" value="Annually">Annually</Option> 
                  </>:
                  contract==="Quarterly"?
                  <>
                  <Option key="monthly" value="Monthly">Monthly</Option>
                  <Option key="quaterly" value="Quarterly">Quarterly</Option>
                  </>:
                  contract==="TwoMonthly"?
                  <>
                  <Option key="monthly" value="Monthly">Monthly</Option>
                  <Option key="twomonthly" value="TwoMonthly">Two Monthly</Option>
                  </>:
                  contract==="SixMonthly"?
                  <>
                  <Option key="monthly" value="Monthly">Monthly</Option>
                  <Option key="quaterly" value="Quarterly">Quarterly</Option>
                  <Option key="sixmonthly" value="SixMonthly">Six Monthly</Option>
                  </>:
                  contract==="TwoYearly"?
                  <>
                  <Option key="monthly" value="Monthly">Monthly</Option>
                  <Option key="quaterly" value="Quarterly">Quarterly</Option>
                  <Option key="sixmonthly" value="SixMonthly">Six Monthly</Option>
                  <Option key="annually" value="Annually">Annually</Option>
                  <Option key="twoyearly" value="TwoYearly">Two Yearly</Option>
                  </>:
                  contract==="ThreeYearly"?
                  <>
                  <Option key="monthly" value="Monthly">Monthly</Option>
                  <Option key="quaterly" value="Quarterly">Quarterly</Option>
                  <Option key="sixmonthly" value="SixMonthly">Six Monthly</Option>
                  <Option key="annually" value="Annually">Annually</Option>
                  <Option key="threeyearly" value="ThreeYearly">Three Yearly</Option>
                  </>:
                  <>
                  <Option key="oneoff" value="One Off">One Off</Option>
                  <Option key="monthly" value="Monthly">Monthly</Option>
                  </>
                }
              </Select>
            </Form.Item>
            <Form.Item
              name="orderProductId"
              label="Order Product Id"
              className="mb-0"
              rules={[
                {
                  required: true,
                  message: "Required field",
                },
              ]}
            >
              <Select placeholder="Select Product">
              {productsOrderList?.map((item) => (
                      <Option key={item.id}
                          value={item.id}
                      >
                      {item.productName}</Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="invoiceCurrency"
              label="Currency"
              className="mb-0"
              rules={[
                {
                  required: true,
                  message: "Required field",
                },
              ]}
            >
              <Select placeholder="Select Currency">
                <Option key="USD" value="USD">USD</Option>
                <Option key="EUR" value="EUR">EUR</Option>
                <Option key="GBP" value="GBP">GBP</Option>
              </Select>
            </Form.Item>
            <Form.Item
              name="contractAmount"
              label="Contract Amount"
              rules={[
                {
                  required: true,
                  message: "Required field",
                },
              ]}
            >
              <InputNumber min={0} onChange={(e)=>setInvoiceAmount(e)} className='w-full' placeholder="Amount"/>
            </Form.Item>    
            <Form.Item
              name="invoiceAmt"
              label="Invoice Amount"
              rules={[
                {
                  required: true,
                  message: "Required field",
                },
              ]}
            >
              <InputNumber disabled min={0} className='w-full' placeholder="Amount"/>
            </Form.Item>   
            <Form.Item name="orderInfo" label="Purchase Order Info."
            >
            {/* <TextArea
              autoSize={{
                minRows: 6,
                maxRows: 12,
              }}
              placeholder=""
            /> */}
            <Input placeholder='Order Info.'/>
           </Form.Item> 
           <Form.Item name="noteToIssuer" label="Note To Issuer:"
            >
            <Input placeholder='Note To Issuer:'/>
           </Form.Item>    
          </div>       
        </Form>
      </Modal>
      <Modal
        title={"Skip This Month"}
        open={isEditModalNoInvoiceOpen}
        onCancel={handleCancelNoInvoice}
        destroyOnClose
        style={{ top: 20 }}
        width={800}
        footer={
          [
          <Button key="cancel" onClick={()=>handleCancelNoInvoice()}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={()=>formNoinvoice.submit()}>
            Save
          </Button>,
        ]
      }
      >
        <Form form={formNoinvoice} name="form_in_modal" layout="vertical" onFinish={saveNoInvoiceDetails}>
          <div className="grid xs:grid-cols-1 lg:grid-cols-2 gap-4">
          <Form.Item
              name="buyersSelected"
              label="Buyer"
              className="mb-0"
              rules={[
                {
                  required: true,
                  message: "Required field",
                },
              ]}
            >
              <Select loading={suplierListLoader} onChange={()=>setDefaultCurrency()} placeholder="Select Buyer"
              showSearch
              filterOption={(input, option) =>
                  option.props.value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
              {buyerBillingList?.map((supplier) => (
                      <Option key={supplier.id}
                          value={supplier.id}
                      >
                      {supplier.buyerName}</Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="contractDatePicker" label="Start Date" className='mb-0'
            rules={[
              {
                required: true,
                message: "Required field",
              },
            ]}
            >
                <DatePicker placeholder='From Date' format={constants.DateFormat2}/>
						</Form.Item>
            {/* <Form.Item
              name="invoiceCurrency"
              label="Currency"
              className="mb-0"
              rules={[
                {
                  required: true,
                  message: "Required field",
                },
              ]}
            >
              <Select placeholder="Select Currency">
                <Option key="USD" value="USD">USD</Option>
                <Option key="EUR" value="EUR">EUR</Option>
                <Option key="GBP" value="GBP">GBP</Option>
              </Select>
            </Form.Item>  */}
            <Form.Item name="skipReason" label="Skip Reason"
            >
            {/* <TextArea
              autoSize={{
                minRows: 6,
                maxRows: 12,
              }}
              placeholder=""
            /> */}
            <Input placeholder='Skip Reason'/>
           </Form.Item>     
          </div>       
        </Form>
      </Modal>
		</div>
   </>
	);
};

export default OrdersAdminCS;